<template>
  <v-container>
    <v-layout
      column
      justify-center
      align-center
      fill-height
    >
      <div class="register-title">
        <h3 class="display-1 font-weight-medium">
          {{ this.$t('register.title') }}
        </h3>
      </div>
      <RegisterForm />
    </v-layout>
  </v-container>
</template>


<script>
import RegisterForm from '../components/RegisterForm'

export default {
  name: 'RegisterView',
  components: {
    RegisterForm,
  },
}
</script>
<style lang="stylus">
.register-title {
  margin-bottom: 2em;
}
</style>
